import Axios from 'axios';
import NProgress from 'nprogress';

const axios = Axios.create({
    baseURL: process.env.REACT_APP_API_ATENDIMENTO_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    crossdomain: true,
    withCredentials: true,
});

axios.interceptors.request.use(async (config) => {
    try {
        const token = sessionStorage.getItem('eRecuperadorJwt');
        if (token) config.headers.Authorization = `Bearer ${token}`;

        NProgress.start();

        return config
            ;
    } catch {
        return null;
    }
});

axios.interceptors.response.use(
    async (config) => {
        try {
            NProgress.done();
            return config;
        } catch {
            return null;
        }
    },
    (error) => {
        try {
            NProgress.done();

            // TODO: Ajustar
            // if (error && error.response && error.response.status === 401) {
            //     localStorage.clear();
            //     window.location = '/';
            // }

            return Promise.reject(error);
        } catch {
            return Promise.reject();
        }
    }
);

export default axios;
